var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('a',{attrs:{"href":"/4","title":"Accedi"}},[_c('img',{attrs:{"src":(_vm.publicPath + "img/intro/ubisell-logo.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }